module.exports = __webpack_public_path__ + "img/℃_icon.3f4cff46.svg";